import { Form, Input } from "antd";
import dayjs from "dayjs";
import { ReactElement } from "react";
import {
  formDateRules,
  formEmailTypeRules,
  formNumberRules,
  formPhoneRules,
  formTextRules,
} from "../../constants/rules/renderFormFields";
import { IField } from "../../interfaces/IField";
import { UI_ITODatePicker } from "../../UI_ITO/UI_ITODatePicker/UI_ITODatePicker";
import { UI_ITONumericInput } from "../../UI_ITO/UI_ITONumericInput/UI_ITONumericInput";

export function RenderFields({ columns }: { columns: IField[] }): ReactElement {
  return (
    <>
      {columns.map((el) => {
        switch (el.type) {
          case "text": {
            const {
              children = <Input size="large" />,
              rules = formTextRules,
              ...restProps
            } = el;

            return (
              <Form.Item {...restProps} rules={rules} key={el.id}>
                {children}
              </Form.Item>
            );
          }
          case "number": {
            const {
              children = <UI_ITONumericInput size="large" maxLength={12} />,
              rules = formNumberRules,
              ...restProps
            } = el;

            return (
              <Form.Item {...restProps} rules={rules} key={el.id}>
                {children}
              </Form.Item>
            );
          }
          case "email": {
            const {
              children = <Input size="large" />,
              rules = formEmailTypeRules,
              ...restProps
            } = el;

            return (
              <Form.Item {...restProps} rules={rules} key={el.id}>
                {children}
              </Form.Item>
            );
          }
          case "phone": {
            const {
              children = <Input size="large" />,
              rules = formPhoneRules,
              ...restProps
            } = el;

            return (
              <Form.Item {...restProps} rules={rules} key={el.id}>
                {children}
              </Form.Item>
            );
          }
          case "date": {
            const {
              children = (
                <UI_ITODatePicker size="large" style={{ width: "100%" }} />
              ),
              rules = formDateRules,
              initialValue = dayjs(new Date()),
              ...restProps
            } = el;

            return (
              <Form.Item
                {...restProps}
                rules={rules}
                key={el.id}
                initialValue={initialValue}
              >
                {children}
              </Form.Item>
            );
          }
          default:
            return <Form.Item {...el}>{el.children}</Form.Item>;
        }
      })}
    </>
  );
}
